import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class AircraftsAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      registration: null,
      cost_center_crew: null,
      cost_center_manager: null,
      aircraft_model_id: null,
      serial_number: null,
      ptbr_code: null,
      ca: null,
      iam: null,
      weight: null,
      ground_consumption: null,
      flight_consumption: null,
      fuel_capacity: null,
      aircraft_models_list: [],
      operation_types: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/aeronave/modelo/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({ aircraft_models_list: responseJson.data });
        }
      }).then(() => {
      var url = config.get('api') + '/tipo/operacoes/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({ operation_types: responseJson.data });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); });
    });
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      registration: this.state.registration,
      cost_center_crew: this.state.cost_center_crew,
      cost_center_manager: this.state.cost_center_manager,
      aircraft_model_id: this.state.aircraft_model_id,
      serial_number: this.state.serial_number,
      ptbr_code: this.state.ptbr_code,
      ca: this.state.ca,
      iam: this.state.iam,
      weight: this.state.weight,
      ground_consumption: this.state.ground_consumption,
      flight_consumption: this.state.flight_consumption,
      fuel_capacity: this.state.fuel_capacity,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aeronave', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success' || responseJson.status === 'warning') {
          var url = '/aeronave/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Aeronaves.AdicionarAeronaves.titulo}</h3>
      <Link to="/aeronaves" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.Modelo}:</label>
              <Select
                className="form-field-name"
                name="aircraft_model_id"
                value={this.state.aircraft_model_id}
                searchable={true}
                placeholder={this.locale.Aeronaves.AdicionarAeronaves.formulario.placeholder.SelecioneModeloAeronave}
                onChange={this.handleSelectChange.bind(this, 'aircraft_model_id')}
                options={this.state.aircraft_models_list}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.Matricula}:</label>
              <input type="text" name="registration" className="form-control" placeholder={this.locale.Aeronaves.AdicionarAeronaves.formulario.placeholder.RegistroAeronave} value={this.state.registration} onChange={this.handleChange.bind(this, 'registration')} required />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.NumeroSerie}:</label>
              <input type="text" name="serial_number" className="form-control" placeholder={this.locale.Aeronaves.AdicionarAeronaves.formulario.placeholder.RegistroAeronave} value={this.state.serial_number} onChange={this.handleChange.bind(this, 'serial_number')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.CA}:</label>
              <InputMask value={this.state.ca}  maskChar={null} name="ca" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'ca')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.IAM}:</label>
              <InputMask value={this.state.iam}  maskChar={null} name="iam" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'iam')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.Peso}:</label>
              <input value={this.state.weight} name="weight" className="form-control" onChange={this.handleChange.bind(this, 'weight')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.CodigoPTBR}:</label>
              <input value={this.state.ptbr_code} name="ptbr_code" className="form-control" onChange={this.handleChange.bind(this, 'ptbr_code')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.ConsumoHoraSolo}:</label>
              <input type="text" placeholder="" className="form-control" name="ground_consumption" value={this.state.ground_consumption} onChange={this.handleChange.bind(this, 'ground_consumption')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.ConsumoHoraVoo}:</label>
              <input type="text" placeholder="" className="form-control" name="flight_consumption" value={this.state.flight_consumption} onChange={this.handleChange.bind(this, 'flight_consumption')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.CapacidadeDeCombustível}:</label>
              <input type="text" placeholder="" className="form-control" name="fuel_capacity" value={this.state.fuel_capacity} onChange={this.handleChange.bind(this, 'fuel_capacity')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Aeronaves.AdicionarAeronaves.formulario.botaoAdicionarAeronave}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default AircraftsAdd;



// WEBPACK FOOTER //
// ./src/Components/Aircrafts/AircraftsAdd.js